import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import CloseIcon from '@wix/da-ds/pkg/Icons/CloseBold';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import { EmoteStreamType } from '../redux/types';
import { streamTypeToSearchType } from '../constants';
import s from './SearchHeader.scss';
const SearchHeader = ({ activeStreamType , onSwitchStream , onClose  })=>{
    const { t  } = useTranslation();
    const [searchQuery, setSearchQuery] = useState('');
    const searchType = streamTypeToSearchType[activeStreamType];
    const handleKeyDown = (e)=>{
        if (e.key === 'Escape') {
            onClose();
        }
        if (e.key === 'Enter') {
            e.target.blur();
            onSwitchStream({
                streamType: EmoteStreamType.SEARCH,
                searchQuery,
                searchType
            });
        }
    };
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("input", {
        "aria-label": searchType !== 'community' ? t('emoteselector.search.users') : t('emoteselector.search'),
        autoFocus: true,
        className: s['search-input'],
        type: "text",
        placeholder: ` ${searchType !== 'community' ? t('emoteselector.search.users') : t('emoteselector.search')}`,
        onChange: (e)=>{
            setSearchQuery(e.target.value);
        },
        onKeyDown: handleKeyDown
    }), /*#__PURE__*/ React.createElement("button", {
        onClick: onClose,
        className: s['close-button'],
        "aria-label": t('emoteselector.search.button.a11y.close')
    }, /*#__PURE__*/ React.createElement(CloseIcon, {
        size: IconSize.SMALL,
        className: s['close-icon']
    })));
};
SearchHeader.displayName = 'SearchHeader';
export default SearchHeader;
